export type SuggestionField={key:string,label:string,kind:string,multiple?:boolean,options?:{value:any,label:string}[],unit?:string};
export function suggestionValue(state:any,key:string){
 if(key==='brands')return state?.brands||[];
 if(key.startsWith('param.'))return state?.params?.find((p:any)=>p.name===key.slice(6))?.values??[];
 return state?.seed?.[key]??'';
}
export function suggestionChanges(input:any,fields:SuggestionField[],state:any){
 if(!input||typeof input!=='object'||Array.isArray(input)||Object.keys(input).length>60)throw Error('Выберите поля для исправления');
 if(JSON.stringify(input).length>220000)throw Error('Предложение слишком большое. Разделите дополнения на несколько правок');
 const result:Record<string,any>={};
 for(const [key,raw] of Object.entries(input)){
  const field=fields.find(f=>f.key===key);if(!field)throw Error('Недоступное поле');
  let value:any=raw;
  if(field.kind==='text'||field.kind==='textarea'){
   if(typeof value!=='string'||value.length>(field.kind==='text'?500:100000))throw Error('Слишком длинное значение');value=value.trim();
   if(key==='title'&&!value)throw Error('Укажите название');
  }else if(field.kind==='range'){
   if(!Array.isArray(value)||value.length!==2)throw Error('Укажите диапазон');
   value=value.map(v=>{if(v===''||v===null)return '';if(!['string','number'].includes(typeof v)||!Number.isFinite(Number(v))||Number(v)<0||Number(v)>1e9)throw Error('Некорректное число');return String(v)});
   if(value.every((v:string)=>v!=='')&&Number(value[0])>Number(value[1]))throw Error('Начало диапазона больше конца');
  }else if(field.kind==='list'){
   if(!Array.isArray(value)||value.length>50||value.some(v=>typeof v!=='string'||v.length>2000))throw Error('Некорректный список');value=value.map(v=>v.trim()).filter(Boolean);
  }else{
   const valid=(v:any)=>field.options?.some(o=>String(o.value)===String(v));
   if(field.multiple){if(!Array.isArray(value)||value.length>200||value.some(v=>!valid(v)))throw Error('Выберите значения из списка');value=[...new Set(value.map(v=>field.options!.find(o=>String(o.value)===String(v))!.value))]}
   else if(value===''||value===null){if(key==='seed_category_id')throw Error('Выберите категорию из списка');value=null;}
   else{if(!valid(value))throw Error('Выберите значение из списка');value=field.options!.find(o=>String(o.value)===String(value))!.value}
  }
  const compare=(v:any)=>{
   if(field.kind==='range')return (Array.isArray(v)?[v[0],v[1]]:[v,'']).map(x=>x===''||x==null?'':String(Number(x)));
   if(field.kind==='select'){
    if(field.multiple)return (Array.isArray(v)?[...v]:v?[v]:[]).map(String).sort();
    const scalar=Array.isArray(v)?v[0]:v;return scalar==null||scalar===''?null:String(scalar);
   }
   if(field.kind==='list')return Array.isArray(v)?v:v?[v]:[];
   return v;
  };
  if(JSON.stringify(compare(value))!==JSON.stringify(compare(suggestionValue(state,key))))result[key]=value;
 }
 return result;
}
export function suggestionDisplay(value:any,field?:SuggestionField){
 const one=(v:any)=>field?.options?.find(o=>String(o.value)===String(v))?.label??String(v??'');
 if(field?.kind==='range')return Array.isArray(value)&&value.some(v=>v!==''&&v!=null)?value.map(v=>v===''||v==null?'—':one(v)).join(' – ')+(field.unit?' '+field.unit:''):'Не указано';
 return (Array.isArray(value)?value.map(one).filter(Boolean).join(', '):one(value))||'Не указано';
}
